/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  BatchUploadRequestSupplierAccountRequestDto,
  BatchUploadReviewSuppliers1Payload,
  BulkDeleteSuppliersRequest,
  CsvReviewResponseSupplierAccountRequestDto,
  GetAllPagedByOrganisation1Params,
  GetSuppliersIdsByOrganisationWithoutPagination1Params,
  InfiniteScrollListSupplierAccountResponseObject,
  LegacySupplierAccountDto,
  SupplierAccountRequest,
  SupplierAccountResponse,
  SuppliersBulkUpdateRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiSupplierAccountController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name AddMissingBicToSupplierAccount1
   * @request PUT:/api/v1/supplier-account/update-missing-bic/{supplierAccountId}
   */
  addMissingBicToSupplierAccount = (supplierAccountId: string, params: RequestParams = {}) =>
    this.http.request<LegacySupplierAccountDto, any>({
      path: `/v1/supplier-account/update-missing-bic/${supplierAccountId}`,
      method: 'PUT',
      format: 'json',
      ...params,
    })

  static addMissingBicToSupplierAccountPath =
    '/v1/supplier-account/update-missing-bic/${supplierAccountId}'
  static addMissingBicToSupplierAccountMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name RemoveSupplierEmployeeMappingBySupplierAccountId1
   * @request PUT:/api/v1/supplier-account/remove-employee-mapping/supplierAccountId/{supplierAccountId}
   */
  removeSupplierEmployeeMappingBySupplierAccountId = (
    supplierAccountId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<LegacySupplierAccountDto, any>({
      path: `/v1/supplier-account/remove-employee-mapping/supplierAccountId/${supplierAccountId}`,
      method: 'PUT',
      format: 'json',
      ...params,
    })

  static removeSupplierEmployeeMappingBySupplierAccountIdPath =
    '/v1/supplier-account/remove-employee-mapping/supplierAccountId/${supplierAccountId}'
  static removeSupplierEmployeeMappingBySupplierAccountIdMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name RemoveSupplierEmployeeMappingByOrganisationAndEmployeeId1
   * @request PUT:/api/v1/supplier-account/remove-employee-mapping/employeeId/{organisationId}/{employeeId}
   */
  removeSupplierEmployeeMappingByOrganisationAndEmployeeId = (
    organisationId: string,
    employeeId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<LegacySupplierAccountDto, any>({
      path: `/v1/supplier-account/remove-employee-mapping/employeeId/${organisationId}/${employeeId}`,
      method: 'PUT',
      format: 'json',
      ...params,
    })

  static removeSupplierEmployeeMappingByOrganisationAndEmployeeIdPath =
    '/v1/supplier-account/remove-employee-mapping/employeeId/${organisationId}/${employeeId}'
  static removeSupplierEmployeeMappingByOrganisationAndEmployeeIdMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name CreateSupplierAccount1
   * @request POST:/api/v1/supplier-account
   */
  createSupplierAccount = (data: SupplierAccountRequest, params: RequestParams = {}) =>
    this.http.request<SupplierAccountResponse, any>({
      path: `/v1/supplier-account`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createSupplierAccountPath = '/v1/supplier-account'
  static createSupplierAccountMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name GetById2
   * @summary Return supplier account by supplier account id
   * @request GET:/api/v1/supplier-account/{supplierAccountId}
   */
  getById = (supplierAccountId: string, params: RequestParams = {}) =>
    this.http.request<SupplierAccountResponse, any>({
      path: `/v1/supplier-account/${supplierAccountId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByIdPath = '/v1/supplier-account/${supplierAccountId}'
  static getByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name UpdateSupplierAccount1
   * @request POST:/api/v1/supplier-account/{supplierAccountId}
   */
  updateSupplierAccount = (
    supplierAccountId: string,
    data: SupplierAccountRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SupplierAccountResponse, any>({
      path: `/v1/supplier-account/${supplierAccountId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateSupplierAccountPath = '/v1/supplier-account/${supplierAccountId}'
  static updateSupplierAccountMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name DeleteSupplierAccount1
   * @request DELETE:/api/v1/supplier-account/{supplierAccountId}
   * @deprecated
   */
  deleteSupplierAccount = (supplierAccountId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/supplier-account/${supplierAccountId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteSupplierAccountPath = '/v1/supplier-account/${supplierAccountId}'
  static deleteSupplierAccountMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name BulkUpdateSuppliers1
   * @request POST:/api/v1/supplier-account/bulk-update
   */
  bulkUpdateSuppliers = (data: SuppliersBulkUpdateRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/supplier-account/bulk-update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkUpdateSuppliersPath = '/v1/supplier-account/bulk-update'
  static bulkUpdateSuppliersMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name BulkDeleteInvoices2
   * @request POST:/api/v1/supplier-account/bulk-delete
   * @deprecated
   */
  bulkDeleteInvoices = (data: BulkDeleteSuppliersRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/supplier-account/bulk-delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkDeleteInvoicesPath = '/v1/supplier-account/bulk-delete'
  static bulkDeleteInvoicesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name BatchUploadSuppliers1
   * @request POST:/api/v1/supplier-account/batch-upload
   */
  batchUploadSuppliers = (
    data: BatchUploadRequestSupplierAccountRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/supplier-account/batch-upload`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static batchUploadSuppliersPath = '/v1/supplier-account/batch-upload'
  static batchUploadSuppliersMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name BatchUploadReviewSuppliers1
   * @request POST:/api/v1/supplier-account/batch-upload/review
   */
  batchUploadReviewSuppliers = (
    data: BatchUploadReviewSuppliers1Payload,
    params: RequestParams = {},
  ) =>
    this.http.request<CsvReviewResponseSupplierAccountRequestDto, any>({
      path: `/v1/supplier-account/batch-upload/review`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static batchUploadReviewSuppliersPath = '/v1/supplier-account/batch-upload/review'
  static batchUploadReviewSuppliersMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name UpdateSupplierAccounting1
   * @request POST:/api/v1/supplier-account/accounting/{supplierAccountId}
   */
  updateSupplierAccounting = (
    supplierAccountId: string,
    data: SupplierAccountRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SupplierAccountResponse, any>({
      path: `/v1/supplier-account/accounting/${supplierAccountId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateSupplierAccountingPath = '/v1/supplier-account/accounting/${supplierAccountId}'
  static updateSupplierAccountingMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name GetByIds1
   * @summary Receive a list of supplier account ids separate by comma and returns a list of supplier account
   * @request GET:/api/v1/supplier-account/{supplierAccountIds}
   */
  getByIds = (supplierAccountIds: string[], params: RequestParams = {}) =>
    this.http.request<SupplierAccountResponse[], any>({
      path: `/v1/supplier-account/${supplierAccountIds}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByIdsPath = '/v1/supplier-account/${supplierAccountIds}'
  static getByIdsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name GetAllByOrganisation1
   * @request GET:/api/v1/supplier-account/organisation
   * @deprecated
   */
  getAllByOrganisation = (params: RequestParams = {}) =>
    this.http.request<SupplierAccountResponse[], any>({
      path: `/v1/supplier-account/organisation`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAllByOrganisationPath = '/v1/supplier-account/organisation'
  static getAllByOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name GetAllPagedByOrganisation1
   * @request GET:/api/v1/supplier-account/organisation/paged
   */
  getAllPagedByOrganisation = (
    query: GetAllPagedByOrganisation1Params,
    params: RequestParams = {},
  ) =>
    this.http.request<InfiniteScrollListSupplierAccountResponseObject, any>({
      path: `/v1/supplier-account/organisation/paged`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllPagedByOrganisationPath = '/v1/supplier-account/organisation/paged'
  static getAllPagedByOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name GetSuppliersIdsByOrganisationWithoutPagination1
   * @request GET:/api/v1/supplier-account/organisation/all/ids
   */
  getSuppliersIdsByOrganisationWithoutPagination = (
    query: GetSuppliersIdsByOrganisationWithoutPagination1Params,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/v1/supplier-account/organisation/all/ids`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getSuppliersIdsByOrganisationWithoutPaginationPath =
    '/v1/supplier-account/organisation/all/ids'
  static getSuppliersIdsByOrganisationWithoutPaginationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-supplier-account-controller
   * @name GetByEmployeeId1
   * @request GET:/api/v1/supplier-account/employee/{employeeId}
   */
  getByEmployeeId = (employeeId: string, params: RequestParams = {}) =>
    this.http.request<SupplierAccountResponse, any>({
      path: `/v1/supplier-account/employee/${employeeId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByEmployeeIdPath = '/v1/supplier-account/employee/${employeeId}'
  static getByEmployeeIdMethod = 'GET'
}
